import React, { useEffect, useState } from "react";
import LV_ART_Articulos_SelectorConGrid from "../Compuestos/Complejos/Articulos/LV_ART_Articulos_SelectorConGrid";
import LVSelectorOperacionesVenta from "../../Componentes/Selectores/LVSelectorOperacionesVenta";
import LVButtonAccion from "../Basicos/LVButtonAccion";
import { FormateoFechaPara_yyyyMMdd_HHmmss } from "neftis7_apicaller/src/funciones/Varios";
import { DateBox } from "devextreme-react";
import LVNumberBoxDocumento from "../Compuestos/Complejos/LVNumberBoxDocumento";
import ComboAbmConMonedas from "../Compuestos/Combos/ComboAbmConMonedas";
import ComboVenListaPreciosCabecera from "../Compuestos/Combos/ComboVenListaPreciosCabecera";
import ComboAbmEexClientes from "../Compuestos/Combos/ComboAbmEexClientes";
import ComboAbmEexClientesLocaciones from "../Compuestos/Combos/ComboAbmEexClientesLocaciones";
import ComboAbmConCondicionesVenta from "../Compuestos/Combos/ComboAbmConCondicionesVenta";
import ComboVenDocsVentaTipos from "../Compuestos/Combos/ComboVenDocsVentaTipos";
import { function_ABM_CON_Monedas_Leer } from "neftis7_apicaller/src/funciones/ABM/CONT/ABM_CON_Monedas";

export const VEN_Pedidos = (props) => {

  const [loading, setLoading] = useState(true);
  const [TituloBoton, setTituloBoton] = useState("");
  const [accionBoton, setAccionBoton] = useState("");
  const [idCliente, setIdCliente] = useState(0);
  const [idPedidoAsignado, setIdPedidoAsignado] = useState(0);
  const [idItemMasAlto, setIdItemMasAlto] = useState(1);
  const [codigoListaPrecios, setCodigoListaPrecios] = useState("");
  const [codigoMoneda, setCodigoMoneda] = useState("");
  const [codigoMonedaReferente, setCodigoMonedaReferente] = useState("");
  const [datosCabecera, setDatosCabecera] = useState([]);
  const [datosConceptoObservaciones, setDatosConceptoObservaciones] = useState([]);
  const [datosDetalle, setDatosDetalle] = useState([]);
  const [idTipo, setIdTipo] = useState(19); //PREDEFINIDO PARA TODA LA PAGINA 
  const [idTipoDocVenta, setIdTipoDocVenta] = useState(1);
  const [cotizacion, setCotizacion] = useState(0);
  const [codigoCondicionVenta, setCodigoCondicionVenta] = useState("");
  const [fecha, setFecha] = useState(new Date());
  const [fechaCompromiso, setFechaCompromiso] = useState(new Date());
  const [conEnvio, setConEnvio] = useState(false);
  const [datosDocumento, setDatosDocumento] = useState([]);
  const [codigoLocacion, setCodigoLocacion] = useState("");
  const [cierreEnProceso, setCierreEnProceso] = useState(false);

  const { VEN_Pedidos_Cabecera: { function_VEN_Pedidos_Cabecera_Insertar,
    function_VEN_Pedidos_Cabecera_Leer,
    function_VEN_Pedidos_Cabecera_Modificar,
    function_VEN_Pedidos_Generar_JSON } } = require('neftis7_apicaller');
  const { ABM_EEX_Clientes: { function_ABM_EEX_Clientes_Leer } } = require('neftis7_apicaller');
  const { VEN_DocsVenta_Cabecera: { function_VEN_DocsVenta_Cabecera_Leer } } = require('neftis7_apicaller');
  const { INV_Remitos_Cabecera: { function_INV_Remitos_Cabecera_Leer } } = require('neftis7_apicaller');
  const { ABM_IMP_PuntosFiscales: { function_ABM_IMP_PuntosFiscales_LeerPorTerminal } } = require('neftis7_apicaller');
  const { Varios: { ObtieneParametros,
    TratamientoDeVariableBoolean } } = require('neftis7_apicaller');

  const [globalUsaArticulosConPresentacion, setGlobalUsaArticulosConPresentacion] = useState(false);
  const [globalUsaArticulosConTamano, setGlobalUsaArticulosConTamano] = useState(false);
  const [globalUsaArticulosConUnidadDeMedida, setGlobalUsaArticulosConUnidadDeMedida] = useState(false);

  const [showPopupAdquirirClonar, setShowPopupAdquirirClonar] = useState(false);
  const [idTipoParaAdquirirClonar, setIdTipoParaAdquirirClonar] = useState(0);
  const [idOperacionParaAdquirirClonar, setIdOperacionParaAdquirirClonar] = useState(0);
  const [totalImporteDelComponenteSelectorArticulos, setTotalImporteDelComponenteSelectorArticulos] = useState(0);

  const handleOnValueChanged_Monedas = async (e) => {
    if (!e.value || e.value == "") {
      setCodigoMoneda("")
      setCotizacion(0)
    } else {
      setCodigoMoneda(e.value)
      const resultMoneda = await function_ABM_CON_Monedas_Leer(e.value)
      if (resultMoneda && resultMoneda.data) {
        setCotizacion(resultMoneda.data[0].Cotizacion)
      }
    }
  };

  const handleOnValueChanged_Clientes = async (e) => {
    if (e.value < 1 || !e.value) {
      setIdCliente(0)
    } else {
      const resultCliente = await function_ABM_EEX_Clientes_Leer(e.value)
      if (resultCliente && resultCliente.data) {
        setIdCliente(e.value)

        if (resultCliente.data.CodigoListaPrecios && resultCliente.data.CodigoListaPrecios !== "") {
          if (codigoListaPrecios === "") {
            setCodigoListaPrecios(resultCliente.data.CodigoListaPrecios);
          } else {
            if (codigoListaPrecios != resultCliente.data.CodigoListaPrecios) {
              if (window.confirm("El Cliente tiene una Lista de Precios asignada, pero ya existe una seleccionada. ¿Desea reemplazarla por la asignada del Cliente?")) {
                setCodigoListaPrecios(resultCliente.data.CodigoListaPrecios);
              }
            }
          }
        }
      }
    }
  };

  const handleOnTotalImporteDelComponenteChange_ = (newTotal) => {
    try {
      setTotalImporteDelComponenteSelectorArticulos(newTotal);
    } catch (error) {
      alert(error)
    }
  };

  const handleOpenAdquirirClonar = async (e) => {
    setShowPopupAdquirirClonar(true)
    setIdTipoParaAdquirirClonar(0)
    setIdOperacionParaAdquirirClonar(0)
  };

  const handleCloseAdquirirClonar = () => {
    setShowPopupAdquirirClonar(false)
    setIdTipoParaAdquirirClonar(0)
    setIdOperacionParaAdquirirClonar(0)
  };

  const handleConfirmAdquirirClonar = async (idTipo, idOperacion) => {
    if (idTipo != 0 && idTipo != undefined && idOperacion != 0 && idOperacion != undefined) {
      setShowPopupAdquirirClonar(false)
      setIdTipoParaAdquirirClonar(idTipo)
      setIdOperacionParaAdquirirClonar(idOperacion)
    } else {
      setShowPopupAdquirirClonar(false)
      setIdTipoParaAdquirirClonar(0)
      setIdOperacionParaAdquirirClonar(0)
    }
  };

  const handleOnClick_Guardar = async (e) => {
    try {
      if (cierreEnProceso) return; // si ya está ejecutando, no hace nada
      setCierreEnProceso(true);

      const JSON = await function_VEN_Pedidos_Generar_JSON(idPedidoAsignado, 1, idTipoDocVenta,
        FormateoFechaPara_yyyyMMdd_HHmmss(fecha), idCliente,
        datosDocumento.numeroFantasia, datosDocumento.codigoPuntoVenta, datosDocumento.numero, "",
        codigoMoneda, cotizacion, 0, 0,
        datosConceptoObservaciones.concepto, datosConceptoObservaciones.observaciones, conEnvio,
        FormateoFechaPara_yyyyMMdd_HHmmss(fechaCompromiso), codigoCondicionVenta, false, 0, false, "", "", null, null,
        codigoMonedaReferente, false, false, false, false,
        localStorage.getItem("IdPersona"), null, codigoLocacion, 0, "", "", 0, 0, datosDetalle, [], [])

      if (props.Codigo.Codigo === "--NUEVO--") {

        const PedidoCreado = await function_VEN_Pedidos_Cabecera_Insertar(JSON, false)

        alert("Se ha generado el Pedido de Venta ID: " + PedidoCreado.data.codigoGenerado)
      } else {

        const PedidoCreado = await function_VEN_Pedidos_Cabecera_Modificar(JSON, false)

        alert("Se ha modificado el Pedido de Venta ID: " + idPedidoAsignado)
      }

      window.location.reload()
    } catch (error) {
      alert(error)
    } finally {
      setCierreEnProceso(false); // Se habilita el botón de nuevo
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const datosModificadores = await ObtieneParametros();
        setGlobalUsaArticulosConPresentacion(await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConPresentacion))
        setGlobalUsaArticulosConTamano(await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConTamano))
        setGlobalUsaArticulosConUnidadDeMedida(await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConUnidadDeMedida))
        setCodigoMoneda(datosModificadores.GlobalMonedaBase)
        setCodigoMonedaReferente(datosModificadores.GlobalMonedaReferente)

        if (props.Codigo.Codigo === "--NUEVO--") {
          setTituloBoton("GUARDAR")
          setAccionBoton("GUARDAR")

          const Terminal = localStorage.getItem("Terminal")
          const resultPuntoFiscal = await function_ABM_IMP_PuntosFiscales_LeerPorTerminal(Terminal, idTipo, 1)

          if (resultPuntoFiscal && resultPuntoFiscal.data && resultPuntoFiscal.data.length > 0) {
            setDatosDocumento({
              codigoPuntoVenta: parseInt(resultPuntoFiscal.data[0].CodigoPuntoFiscal),
              codigoPuntoVentaFormateado: resultPuntoFiscal.data[0].CodigoPuntoFiscal.toString().substring(0, 4).padStart(4, '0'),
            })

            if (resultPuntoFiscal.data[0].CodigoListaPrecios && resultPuntoFiscal.data[0].CodigoListaPrecios !== "") {
              if (codigoListaPrecios === "") {
                setCodigoListaPrecios(resultPuntoFiscal.data[0].CodigoListaPrecios);
              } else {
                if (codigoListaPrecios != resultPuntoFiscal.data[0].CodigoListaPrecios) {
                  setCodigoListaPrecios(resultPuntoFiscal.data[0].CodigoListaPrecios);
                }
              }
            }
          } else {
            setDatosDocumento({
              codigoPuntoVenta: 0,
              codigoPuntoVentaFormateado: "0000"
            })
          }
        } else {
          setTituloBoton("ACTUALIZAR ID " + props.Codigo.Codigo)
          setAccionBoton("ACTUALIZAR ID " + props.Codigo.Codigo)

          setIdPedidoAsignado(props.Codigo.Codigo)

          const datosDocumento = await function_VEN_Pedidos_Cabecera_Leer(props.Codigo.Codigo)

          setIdCliente(datosDocumento.data.IdCliente)
          setCodigoMoneda(datosDocumento.data.CodigoMoneda)
          setCotizacion(datosDocumento.data.Cotizacion)
          setCodigoCondicionVenta(datosDocumento.data.CodigoCondicionVenta)
          setFecha(new Date(datosDocumento.data.Fecha))
          setFechaCompromiso(new Date(datosDocumento.data.FechaCompromiso))
          setCodigoLocacion(datosDocumento.data.CodigoLocacion)
          setCodigoMoneda(datosDocumento.data.CodigoMoneda)
          setCodigoMonedaReferente(datosDocumento.data.CodigoMonedaReferente)
          setConEnvio(datosDocumento.data.ConEnvio)
          setIdTipoDocVenta(datosDocumento.data.IdTipoDocVenta)
          setCotizacion(datosDocumento.data.Cotizacion)
          setDatosConceptoObservaciones({
            concepto: datosDocumento.data.Concepto,
            observaciones: datosDocumento.data.Observaciones
          })

          if (datosDocumento.data.Detalles && datosDocumento.data.Detalles.length > 0) {
            const idMasAlto = datosDocumento.data.Detalles.reduce((maxId, detalle) => {
              return detalle.IdItem > maxId ? detalle.IdItem : maxId;
            }, 0);

            const nuevosDatosDetalle = datosDocumento.data.Detalles.map(detalle => {
              return {
                ...detalle,
                id: detalle.IdItem,
                ImporteBonificaciones: detalle.ImporteDescuentos,
                ImporteNetoTotal: detalle.ImporteNeto * detalle.Cantidad,
                ImporteDescuentosTotal: detalle.ImporteDescuentos * detalle.Cantidad,
                ImporteRecargosTotal: detalle.ImporteRacargos * detalle.Cantidad,
                ImporteIVATotal: detalle.ImporteIVA * detalle.Cantidad,
                ImporteImpuestosInternosTotal: detalle.ImporteImpuestosInternos * detalle.Cantidad
              };
            });

            setDatosDetalle(nuevosDatosDetalle);

            setIdItemMasAlto(idMasAlto + 1)
          }
        }

        setLoading(false);
      } catch (error) {
        alert(error)
      }
    };

    fetchData();
  }, []);


  useEffect(() => {
    const fetchData = async () => {
      try {
        let datosDocumento
        let IdPedidoReferenteAdquirido = 0

        //DOCUMENTO VENTA
        if ([1, 2, 3, 11, 12, 13, 21, 22, 23, 31, 32, 33, 41, 42, 43, 51, 52, 53, 61, 62, 63, 71, 72, 73, 81, 82, 83, 91, 92, 93].includes(idTipoParaAdquirirClonar)) {
          datosDocumento = await function_VEN_DocsVenta_Cabecera_Leer(idOperacionParaAdquirirClonar)

          if (datosDocumento.data != undefined) {
            IdPedidoReferenteAdquirido = datosDocumento.data.idPedidoReferente
          }
        }

        //PEDIDO
        if (idTipoParaAdquirirClonar === 101) {
          datosDocumento = await function_VEN_Pedidos_Cabecera_Leer(idOperacionParaAdquirirClonar)
        }

        //COTIZACION
        if (idTipoParaAdquirirClonar === 102) {
          datosDocumento = await function_VEN_Pedidos_Cabecera_Leer(idOperacionParaAdquirirClonar)

          datosDocumento.data.Detalles = datosDocumento.data.Detalles.map(detalle => ({
            ...detalle,
            IdItemCotizacion: detalle.IdItem
          }));
        }

        //REMITO
        if (idTipoParaAdquirirClonar === 301) {
          datosDocumento = await function_INV_Remitos_Cabecera_Leer(idOperacionParaAdquirirClonar)

          datosDocumento.data.Detalles = datosDocumento.data.Detalles.map(detalle => ({
            ...detalle,
            IdItemRemito: detalle.IdItem
          }));
        }

        if (datosDocumento && datosDocumento.data) {
          setIdCliente(datosDocumento.data.IdCliente)
          setCodigoMoneda(datosDocumento.data.CodigoMoneda)
          setCotizacion(datosDocumento.data.Cotizacion)
          setCodigoCondicionVenta(datosDocumento.data.CodigoCondicionVenta)
          setDatosConceptoObservaciones({
            concepto: datosDocumento.data.Concepto,
            observaciones: datosDocumento.data.Observaciones
          })

          if (datosDocumento.data.Detalles && datosDocumento.data.Detalles.length > 0) {
            const idMasAlto = datosDocumento.data.Detalles.reduce((maxId, detalle) => {
              return detalle.IdItem > maxId ? detalle.IdItem : maxId;
            }, 0);

            const nuevosDatosDetalle = datosDocumento.data.Detalles.map(detalle => {
              return {
                ...detalle,
                id: detalle.IdItem,
                ImporteBonificaciones: detalle.ImporteDescuentos,
                ImporteNetoTotal: detalle.ImporteNeto * detalle.Cantidad,
                ImporteDescuentosTotal: detalle.ImporteDescuentos * detalle.Cantidad,
                ImporteRecargosTotal: detalle.ImporteRacargos * detalle.Cantidad,
                ImporteIVATotal: detalle.ImporteIVA * detalle.Cantidad,
                ImporteImpuestosInternosTotal: detalle.ImporteImpuestosInternos * detalle.Cantidad
              };
            });

            setDatosDetalle(nuevosDatosDetalle);

            setIdItemMasAlto(idMasAlto + 1)
          }
        }

        setLoading(false);
      } catch (error) {
        alert(error)
      }
    };

    fetchData();
  }, [idTipoParaAdquirirClonar, idOperacionParaAdquirirClonar]);

  return (
    <>
      {loading ? (
        <div className="card-body text-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Cargando...</span>
          </div>
        </div>
      ) : (
        <div>
          <div className="LV-GroupBox-div"
            style={{ marginLeft: '6px', marginRight: '6px', marginBottom: '7px', alignItems: 'center', justifyContent: 'center', gap: '30px' }}>
            <div className="LV-FlexContainer" style={{ gap: '20px'}}>
              <ComboAbmEexClientes onValueChanged={handleOnValueChanged_Clientes} value={idCliente} ancho="1020" />
              {idCliente > 0 && (
                <>
                  Locación de Entrega

                  <ComboAbmEexClientesLocaciones
                    onValueChanged={(e) => setCodigoLocacion(e.value)}
                    value={codigoLocacion}
                    ancho="500"
                    IdCliente={idCliente}
                  />
                </>
              )}
            </div>
            <div className="LV-FlexContainer"
              style={{ marginBottom: '10px', marginTop: '10px', alignItems: 'center', justifyContent: 'center', gap: '20px' }}>

              <div style={{ marginLeft: '0px' }}>

              </div>

              <div style={{ display: 'flex', gap: '5px', alignItems: 'center', justifyContent: 'center', flexGrow: 1 }}>
                Fecha
                <DateBox displayFormat="dd/MM/yyyy" value={fecha} onValueChanged={(e) => setFecha(e.value)} width={120} />

                <div style={{ width: '20px' }}></div>

                <ComboAbmConCondicionesVenta onValueChanged={(e) => setCodigoCondicionVenta(e.value)} value={codigoCondicionVenta} />

                <div style={{ width: '20px' }}></div>

                Compromiso
                <DateBox displayFormat="dd/MM/yyyy" value={fechaCompromiso} onValueChanged={(e) => setFechaCompromiso(e.value)} width={120} />

                <div style={{ width: '70px' }}></div>

                <LVNumberBoxDocumento
                  IdTipo={idTipo}
                  IdTipoMovimiento={1}
                  DatosDocumento={datosDocumento}
                  SetDatosDocumento={setDatosDocumento} />

                <div style={{ width: '70px' }}></div>

                <ComboAbmConMonedas onValueChanged={handleOnValueChanged_Monedas} value={codigoMoneda} />

                <div style={{ width: '70px' }}></div>

                <ComboVenDocsVentaTipos onValueChanged={(e) => setIdTipoDocVenta(e.value)} value={idTipoDocVenta} />
              </div>

              <div style={{ marginRight: '0px' }}>
                <ComboVenListaPreciosCabecera onValueChanged={(e) => setCodigoListaPrecios(e.value)} value={codigoListaPrecios} ancho="290" />
              </div>

            </div>
          </div>

          <LV_ART_Articulos_SelectorConGrid
            idEEX={idCliente}
            esCompras={false}
            esVentas={true}
            codigoListaPrecios={codigoListaPrecios}
            tieneEnCuentaLPdelCliente={true}
            codigoMonedaEnviadaPorDocumento={codigoMoneda}
            tienePresentaciones={globalUsaArticulosConPresentacion}
            tieneTamanos={globalUsaArticulosConTamano}
            tieneUnidadesMedida={globalUsaArticulosConUnidadDeMedida}
            DatosDetalle={datosDetalle}
            DatosConceptoObservaciones={datosConceptoObservaciones}
            setDatosDetalle={setDatosDetalle}
            setDatosConceptoObservaciones={setDatosConceptoObservaciones}
            IdItemMasAlto={idItemMasAlto}
            muestraComponentesDelTotal={true}
            onTotalImporteDelComponenteChange={handleOnTotalImporteDelComponenteChange_}
            Comprables={0}
            Vendibles={1}
            Fabricables={0}
            Stockeables={0}
            Servicios={0}
            ExcluirVendibles={0}
            ExcluirComprables={0}
            ExcluirFabricables={0}
            ExcluirStockeables={0}
            ExcluirServicios={0}
            PermiteVisualizarStock={true}
            PermiteVenderConPrecioCero={true}
            pageSize={20} />

          <div style={{ display: 'flex', marginBottom: '5px', marginTop: '20px', alignItems: 'center', justifyContent: 'center', gap: '50px' }}>
            <LVButtonAccion Texto="ADQUIRIR / CLONAR" onClick={handleOpenAdquirirClonar} />
            {showPopupAdquirirClonar ? (
              <>
                <LVSelectorOperacionesVenta onConfirm={(idTipo, idOperacion) => handleConfirmAdquirirClonar(idTipo, idOperacion)} onClose={handleCloseAdquirirClonar} />
              </>
            ) : null}

            <LVButtonAccion
              Disabled={cierreEnProceso} Texto={TituloBoton} onClick={handleOnClick_Guardar} />
          </div >
        </div >
      )}
    </>
  )
};